import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Label } from '@abyss/web/ui/Label';
import { Button } from '@abyss/web/ui/Button';
import { useRouter } from '@abyss/web/hooks/useRouter';

export const NotFound = () => {
  const { navigate } = useRouter();

  const goHome = () => {
    navigate('/');
  };

  return (
    <Box
      padding={40}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        minHeight: '60vh',
      }}
    >
      <Label size="xxl" fontWeight="bold" color="$red6">
        404
      </Label>

      <Label size="xl" fontWeight="semibold" color="$gray8">
        Page Not Found
      </Label>

      <Label
        size="md"
        color="$gray6"
        css={{ textAlign: 'center', maxWidth: '500px' }}
      >
        The page you're looking for doesn't exist. Please check the URL or
        return to the home page.
      </Label>

      <Button variant="solid" size="lg" onClick={goHome}>
        Go Home
      </Button>
    </Box>
  );
};
